import { Currency, isCurrency } from "@redotech/money/currencies";

/**
 * Minimal shape needed to resolve a team's store currency. Structural so it
 * accepts the model `Team`, the hydrated schema team, `ctx.team`, and lean docs
 * without depending on `@redotech/backend-db-schema` (which would cycle), and so
 * the frontend (which can't import server-only packages) can use it too.
 */
interface TeamCurrencyFields {
  settings?: { currencyOverride?: string | null } | null;
  _shopify?: { currency?: unknown } | null;
}

/**
 * The currency a team's amounts are presented in: an operator-set
 * `settings.currencyOverride` (used for non-Shopify stores that have no real
 * Shopify currency) wins over the Shopify-synced `_shopify.currency`.
 */
export function getShopCurrencyWithDefault({
  team,
  defaultCurrency = Currency.USD,
}: {
  team: TeamCurrencyFields | null | undefined;
  defaultCurrency?: Currency;
}): Currency {
  return getShopCurrency({ team }) ?? defaultCurrency;
}

export function getShopCurrency({
  team,
}: {
  team: TeamCurrencyFields | null | undefined;
}): Currency | undefined {
  const override = team?.settings?.currencyOverride;
  if (typeof override === "string" && isCurrency(override)) {
    return override;
  }
  const rawShopCurrency = team?._shopify?.currency;
  return typeof rawShopCurrency === "string" && isCurrency(rawShopCurrency)
    ? rawShopCurrency
    : undefined;
}
